// extracted by mini-css-extract-plugin
export default {"childWrapper":"Layout_childWrapper__+7nSl","menuContainer":"Layout_menuContainer__SrxSI","footerBarCollection":"Layout_footerBarCollection__NcDi1"};